import WebCheckInTypes from './webCheckIn.types';
import { decodeHexResponse } from '../_common/common.utils';

const INITIAL_STATE = {
	createWebCheckInResponse: null,
	todayAttendanceStatus: null,
	regularizeAttendanceResponse: null,
};

const webCheckInReducer = (state = INITIAL_STATE, action: { type: string; payload?: any }) => {
	if (process.env.NODE_ENV === 'development') console.log('Web Check-In reducer called with action:', action.type, action.payload);

	switch (action.type) {
		// Create Web Check-In
		case WebCheckInTypes.CREATE_WEB_CHECK_IN_START:
			return { ...state, createWebCheckInResponse: null };
		case WebCheckInTypes.CREATE_WEB_CHECK_IN_SUCCESS:
			return {
				...state,
				createWebCheckInResponse: decodeHexResponse(
					action.payload,
					WebCheckInTypes.CREATE_WEB_CHECK_IN_KEY,
				),
			};
		case WebCheckInTypes.CREATE_WEB_CHECK_IN_FAILURE:
			return {
				...state,
				createWebCheckInResponse: decodeHexResponse(
					action.payload,
					WebCheckInTypes.CREATE_WEB_CHECK_IN_KEY,
				),
			};

		// Fetch today's attendance status
		case WebCheckInTypes.FETCH_TODAY_ATTENDANCE_START:
			return { ...state, todayAttendanceStatus: null };
		case WebCheckInTypes.FETCH_TODAY_ATTENDANCE_SUCCESS:
			return {
				...state,
				todayAttendanceStatus: decodeHexResponse(
					action.payload,
					WebCheckInTypes.FETCH_TODAY_ATTENDANCE_KEY,
				),
			};
		case WebCheckInTypes.FETCH_TODAY_ATTENDANCE_FAILURE:
			return {
				...state,
				todayAttendanceStatus: decodeHexResponse(
					action.payload,
					WebCheckInTypes.FETCH_TODAY_ATTENDANCE_KEY,
				),
			};

		// Regularize attendance
		case WebCheckInTypes.REGULARIZE_ATTENDANCE_START:
			return { ...state, regularizeAttendanceResponse: null };
		case WebCheckInTypes.REGULARIZE_ATTENDANCE_SUCCESS:
			return {
				...state,
				regularizeAttendanceResponse: decodeHexResponse(
					action.payload,
					WebCheckInTypes.REGULARIZE_ATTENDANCE_KEY,
				),
			};
		case WebCheckInTypes.REGULARIZE_ATTENDANCE_FAILURE:
			// Handle both encrypted response objects and plain error strings
			if (typeof action.payload === 'string') {
				// Plain error message from exception
				return {
					...state,
					regularizeAttendanceResponse: {
						status: 'error',
						message_text: action.payload,
					},
				};
			} else if (action.payload && action.payload.response) {
				// Encrypted response object
				return {
					...state,
					regularizeAttendanceResponse: decodeHexResponse(
						action.payload,
						WebCheckInTypes.REGULARIZE_ATTENDANCE_KEY,
					),
				};
			} else {
				// Fallback for other error formats
				return {
					...state,
					regularizeAttendanceResponse: {
						status: 'error',
						message_text: action.payload?.message || action.payload?.message_text || 'Unable to regularise attendance',
					},
				};
			}

		// Response Management
		case WebCheckInTypes.WEB_CHECK_IN_RESPONSE_CHANGED:
			return {
				...state,
				createWebCheckInResponse: null,
				regularizeAttendanceResponse: null,
			};
		case WebCheckInTypes.WEB_CHECK_IN_RESPONSE_REST_START:
			return {
				...state,
				createWebCheckInResponse: null,
				todayAttendanceStatus: null,
				regularizeAttendanceResponse: null,
			};
		default:
			return state;
	}
};

export default webCheckInReducer;
